import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'indexOf',
  pure: false
})
export class IndexOfPipe implements PipeTransform {

  transform(list: any, args: any): any {
    if (list == null || args == null) {
      return null;
    }
    const index = list.findIndex((item) => (item.media && item.media['@id']) ? item.media['@id'] === args.item : false);

    if (index === -1) {
      return null;
    }

    return index + 1;
  }
}
